import { Query } from '../../_base/actionBus/Query';
import { Announcement } from '../../models/announcements/Announcement';

export class GetAnnouncements extends Query<Announcement[]> {}
